import ProgressBar from '@luminopia/react-toolbox/lib/progress_bar';
import { List, ListItem } from '@luminopia/react-toolbox/lib/list';
import { Table, TableCell, TableHead, TableRow } from '@luminopia/react-toolbox/lib/table';
import { IFormFields, PasswordChange, passwordChangeFormFactory } from 'study_reviewer/components/passwordChange';
import Search from 'core/components/search';
import * as React from 'react';
import { routeProps } from 'core/utils/react-router-helpers';
import { connect, Dispatch } from 'react-redux';
import Card from 'study_reviewer/components/Card';
import { Redirect, RouteComponentProps, withRouter } from 'react-router';
import { reviewerShowRoute } from 'study_reviewer/routes';
import { IState, changePasswordRequest, getTechnicianPhysiciansRequest } from 'study_reviewer/store';
import { IReviewer } from "../store/reviewers/model"
import { model as ReviewersModel, selectReviewers } from 'study_reviewer/store/reviewers';
import { ReviewerControls, ReviewerSummary } from 'study_reviewer/components/reviewers';
import * as styles from './LoginPage.css'

export interface IReviewerRow {
  firstName: string;
  lastName: string;
  npi: string;
  email: string;
  isApproved: boolean;
}

interface IStateProps {
  isFetching: boolean;
  physicians: IReviewerRow[]
}

interface IDispatchProps {
  onMount?: () => void;
}

interface IOwnProps extends RouteComponentProps<IRouteParams> {
  currentReviewer: IReviewer | null
}

export interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

interface IComponentState {
  filterValue: string;
}

export interface IRouteParams {
  npi: string;
}

const id = '';
const PASSWORD_FORM_NAME = 'passwordChange';
const onSubmit = (data: IFormFields, dispatch: Dispatch<void>) => {
  dispatch(changePasswordRequest(id, data, PASSWORD_FORM_NAME));
};
const PasswordChangeForm = passwordChangeFormFactory({ formName: PASSWORD_FORM_NAME, onSubmit });

export class AccountPage extends React.Component<IProps, IComponentState> {
  public state = {
    filterValue: '',
  };

  public render() {
    const { isFetching, physicians, currentReviewer } = this.props
    if (isFetching) {
      return <ProgressBar type='circular' mode='indeterminate' multicolor />;
    }

    if (!currentReviewer) return null

    return (
      <div>
        <Card title='My Account' icon='person_outline'>
          <List>
            <ListItem
              legend='If you require any updates to your account profile, please contact Luminopia Support.'
              leftIcon='warning'
              ripple={false}
            />
            <ListItem
              legend='Name'
              caption={`${currentReviewer.firstName} ${currentReviewer.lastName}`}
              leftIcon='badge'
              ripple={false}
            />
            {!currentReviewer.isTechnician && (
              <ListItem
                legend='NPI'
                caption={currentReviewer.npi}
                leftIcon='fingerprint'
                ripple={false}
              />
            )}
            <ListItem
              legend='Email'
              caption={currentReviewer.email}
              leftIcon='person'
              ripple={false}
            />
            {currentReviewer.isTechnician && (
              <ListItem
                legend={`${physicians.length === 1 ? 'Physician' : 'Physicians'} that granted patient access`}
                caption={physicians.length === 0 ? 'None' : physicians.map(p => `${p.firstName} ${p.lastName}`).join(', ')}
                leftIcon='medical_services'
                ripple={false}
              />
            )}
          </List>
          <PasswordChangeForm
            initialValues={{
              email: currentReviewer.email,
              id: currentReviewer.id,
            }}
          >
            {(values: IFormFields) => <PasswordChangeForm initialValues={values} />}
          </PasswordChangeForm>

        </Card>
      </div>
    );
  }

  public componentDidMount() {
    if (this.props.onMount) {
      this.props.onMount();
    }
    if (this.props.currentReviewer && !this.props.currentReviewer.isApproved) {
      this.props.history.push(reviewerShowRoute());
    }
  }
}

const mapStateToProps = (state: IState): IStateProps => {
  return {
    isFetching: state.reviewers.isFetching,
    physicians: selectReviewers(state)
  };
};

const mapDispatchToProps = (dispatch: Dispatch<void>, ownProps: IOwnProps) => ({
  onMount: () => {
    const { currentReviewer } = ownProps
    if (currentReviewer && currentReviewer.isTechnician) {
      dispatch(getTechnicianPhysiciansRequest(currentReviewer.id))
    }
  },
})

export default connect<IStateProps, IDispatchProps, IOwnProps, IState>(
  mapStateToProps,
  mapDispatchToProps,
)(AccountPage);



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/pages/AccountPage.tsx